import { useSpring, animated } from "@react-spring/web";
import { useRef } from "react";
import { IoMdClose } from "react-icons/io";
import { useClickAway } from 'react-use';

const Sidebar = ({ isOpen, child, close }) => {
    const ref = useRef();
    const spring = useSpring({
        translateX: isOpen ? "0vw" : "100vw",
        display: isOpen ? "block" : "none"
    })

    useClickAway(ref, () => {
        close();
    })

    return (
        <animated.div
            ref={ref}
            className="fixed right-0 bottom-0 w-full md:w-2/3 xl:w-1/4 bg-skgBlue overflow-y-auto overflow-x-hidden z-30 pb-3"
            style={{
                top: 72,
                ...spring
            }}
        >
            <div
                className="p-3"
            >
                <IoMdClose
                    color="white"
                    size={35}
                    onClick={close}
                />
            </div>
            {child}
        </animated.div>
    )
}

export default Sidebar;